import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { timeDisplayFormat } from "../../utils/utils";

const DayCalendarSchedules = ({ timeSchedules, onScheduleClick }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const targetId = timeSchedules.length > 0 ? timeSchedules[0].id : "";

  return (
    <>
      {timeSchedules
        .filter((timeSchedule) => {
          if (user?.role === "teacher") {
            return timeSchedule.status !== "pending";
          }
          return true;
        })
        .map((item) => {
          const time = moment.tz(
            item.scheduledDate + "T" + item.scheduledStartTime + ".000",
            item.originalScheduledTimezoneName,
          );
          const timeStart = time.clone().tz(user.timezone).format(timeDisplayFormat(user?.timeDisplayFormat));
          const timeEnd = time
            .clone()
            .tz(user.timezone)
            .add(30, "minutes")
            .format(timeDisplayFormat(user?.timeDisplayFormat));

          return (
            <div
              key={item.id}
              className={`calendarSchedule
                ${item.status === "done" ? "done" : ""}
                ${item.status === "noShow" ? "noShow" : ""}
                ${item.status === "pending" ? "pending" : ""}
                ${item.status === "canceled" ? "outLimit" : ""}
                ${item.status === "canceledFree" ? "canceled" : ""}`}
              onClick={(e) => onScheduleClick(e, targetId)}
            >
              <p className="calendarScheduleTime">
                {`${timeStart} - ${timeEnd}`} {t(item?.lingoLanguage?.language?.name.toUpperCase())}{" "}
                {item.target === "demo" && item.target.toUpperCase()}
              </p>
            </div>
          );
        })}
    </>
  );
};

export default DayCalendarSchedules;
